import React from 'react';
import { Box, Pill, TagIcon } from '@myob/myob-widgets';
import { get } from 'lodash';
import { useProductData } from 'hooks/useProductData/useProductData';
import { useSessionContext } from 'contexts/sessionProvider/SessionProvider';
import { PricingMolecule } from '../priceMolecule/PricingMolecule';
import soloStyles from './PricingCard.solo.module.scss';
import defaultStyles from './PricingCard.module.scss';
import commonStyles from './PricingCard.common.module.scss';
import { FEELIX_THEMES } from '../../../constants';
import { ModulePrice, ModulePriceText } from '../modulePrice/ModulePrice';

type PriceProps = {
  price: string;
  currency: string;
  isExcludeTax: boolean;
}
type PricingCardProps = {
  pricing: PriceProps,
  theme: string,
  productDisplayName?: string
}

const getPriceDenominator = (paymentSchedule: string, isExcludeTax: boolean, theme: string) => {
  if (theme === FEELIX_THEMES.COMMON) {
    return `/${paymentSchedule}`;
  }

  const taxDescription = isExcludeTax ? '(+ GST)' : '(inc. GST)';
  return `/${paymentSchedule} ${taxDescription}`;
};

const getStyle = (theme: string) => {
  if (theme === FEELIX_THEMES.SOLO) {
    return soloStyles;
  }

  if (theme === FEELIX_THEMES.COMMON) {
    return commonStyles;
  }

  return defaultStyles;
};
export const PricingCard: React.FC<PricingCardProps> = ({
  pricing: {
    price, isExcludeTax, currency
  },
  theme,
  productDisplayName
}) => {
  const style = getStyle(theme);
  const { isAnnualPrice } = useSessionContext();
  const isCommonTheme = theme === FEELIX_THEMES.COMMON;
  const paymentSchedule = isCommonTheme || !isAnnualPrice ? 'month' : 'year';
  const { productData, moduleProductData } = useProductData();
  const productItems = get(productData, 'items');
  const promotionName = get(productItems[0], 'deal.promotionName');

  return (
    <Box className={style.pricingCard}>
      {promotionName && (<Pill label={promotionName}
        prefixAccessory={<TagIcon color={'inherit'} />} className={style.offerPill}
      />)}
      <PricingMolecule
        price={price}
        denominator={getPriceDenominator(paymentSchedule, isExcludeTax, theme)}
        currency={currency}
        theme={theme}
        productDisplayName={productDisplayName}
      />
      {theme === FEELIX_THEMES.COMMON ? (
        <ModulePriceText
          productData={productData}
          moduleProductData={moduleProductData}
          className={style.modulePriceText}
        />
      ) : (
        <ModulePrice
          productData={productData}
          moduleProductData={moduleProductData}
        />
      )}
    </Box>
  );
};
